export interface ISysOption {
    name: string,
    value: string
}

export enum SysOptionEnum {
    BlogAllowed = "BlogAllowed",
    OrdersAllowed = "OrdersAllowed"
}



// WEBPACK FOOTER //
// ./src/models/sys/sys-option.ts